import React from 'react';
import { connect } from 'react-redux';
// GameGuide imports
import GuideStepContainer from '../layout';
import PlayerPreview from './playerPreview';
import RangeSlider from '../../Default/RangeSlider';
import { nextStep } from '../../../actions/gameGuideActions';
// Game(kit) imports
import AssetsManager from '../../../../Game/Base/AssetManager';
import LibraryManager from '../../../../Game/Base/Library/LibraryManager';
import { playerSettings } from '../../../../GameKit/shared';
import gameKit from '../../../../GameKit';

import settings from '../../../../settings';
import AssetRowPicker from '../../AssetRowPicker';

class GuideStepPlayer extends React.Component {
    onLivesChange = lives => {
        gameKit.updatePlayerSettings({
            lives
        });
    };

    onWeightChange = weight => {
        gameKit.updatePlayerSettings({
            weight
        });
    };

    // onBounceChange expects an un-normalized bounce value
    onBounceChange = bounce => {
        const normalValue = playerSettings.normalizeBounce(parseInt(bounce, 10));
        // Update player settings in gamekit (with dispatch = true)
        gameKit.updatePlayerSettings({
            bounce: normalValue
        });
    };

    handleChangeHat = newAsset => {
        gameKit.updatePlayerSettings({
            hat: newAsset.id
        });
    };

    handleChangeBody = newAsset => {
        gameKit.updatePlayerSettings({
            texture: newAsset.id
        });
    };

    handleTextureHueChange = textureHue => {
        gameKit.updatePlayerSettings({
            textureHue
        });
    };

    onNext = () => {
        const { dispatch } = this.props;
        dispatch(nextStep());
    };

    render() {
        const { game, id } = this.props;

        const hats = LibraryManager.hats._categories.map(c => c.getItems().map(i => ({ id: i.id, src: i.getSide().baseTexture.imageUrl }))).flat();
        const textures = LibraryManager.textures._categories.map(c => c.getItems().map(i => ({ id: i.id, src: i.get().baseTexture.imageUrl }))).flat();

        return (
            <GuideStepContainer title={<div>Maak je speler</div>} id={id} hasSaveButton>
                <div className="player-step-columns">
                    <div className="player-step-column column-sliders">
                        <CustomSliderRow
                            title="Levens"
                            min={playerSettings.livesMin}
                            max={playerSettings.livesMax}
                            step={playerSettings.livesStep}
                            value={game.player.lives}
                            onChange={this.onLivesChange}
                            icon={`${settings.assetsPath}img/icons/heart.png`}
                        />
                        <CustomSliderRow
                            title="Gewicht"
                            value={game.player.weight}
                            min={playerSettings.weightMin}
                            max={playerSettings.weightMax}
                            step={playerSettings.weightStep}
                            onChange={this.onWeightChange}
                            icon={`${settings.assetsPath}img/icons/wipwap.png`}
                        />
                        <CustomSliderRow
                            title="Stuiter"
                            value={game.player.bounce}
                            min={playerSettings.bounceMin}
                            max={playerSettings.bounceMax}
                            step={playerSettings.bounceStep}
                            sliderStep={playerSettings.bounceStepSlider}
                            onChange={this.onBounceChange}
                            icon={`${settings.assetsPath}img/icons/bounce.png`}
                        />
                    </div>
                    <div className="player-step-column column-preview">
                        <PlayerPreview game={game} />
                        <div className="player-hue-label"></div>
                    </div>
                    <div className="player-step-column column-pickers">
                        <div className="player-asset-picker-row">
                            <AssetRowPicker activeItem={game.player.hat} items={hats} draggable={false} handleItemClick={this.handleChangeHat} currentCategory="playerHat" />
                        </div>
                        <div className="player-asset-picker-row">
                            <AssetRowPicker activeItem={game.player.texture} items={textures} draggable={false} handleItemClick={this.handleChangeBody} currentCategory="playerBody" />
                        </div>
                    </div>
                </div>
                <div className="hue-slider-columns">
                    <div className="hue-slider">
                        <span>Verkleuren</span>
                        <RangeSlider
                            background="linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)"
                            property=""
                            currentValue={game.player.textureHue}
                            min={0}
                            max={360}
                            step={1}
                            onChange={this.handleTextureHueChange}
                            hideValues
                        />
                    </div>
                </div>
                <div className="buttons-container">
                    <div></div>
                    <button type="button" onClick={this.onNext} className="player-next-button">
                        verder
                    </button>
                </div>
            </GuideStepContainer>
        );
    }
}

function CustomSliderRow({ title, icon, min, max, step, sliderStep, value, onChange, iconStyle }) {
    return (
        <div className="custom-slider-row">
            <div className="column custom-slider-row-label">{title}</div>
            <div className="column custom-slider-row-icon">
                <img src={icon} alt="slider icon" style={iconStyle} />
            </div>
            <div className="column">
                <RangeSlider min={min} max={max} step={step} sliderStep={sliderStep} onChange={onChange} currentValue={value} />
            </div>
        </div>
    );
}

GuideStepPlayer.defaultProps = {};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    game: state.game
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GuideStepPlayer);
